module.exports = __webpack_public_path__ + "static/media/foto2.b8e1941c.png";